// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Import clienti via CSV/Excel ======
// Riusa parseCSV() definito in sicurezza.js. L'utente scarica un template
// (csv-template-clienti) e lo rimanda popolato. Compatibile con .xlsx
// solo se l'utente lo esporta in CSV (no XLSX parser per restare a 0 deps).

const CLIENTI_TEMPLATE_HEADER = [
  'nome',
  'cpl',
  'pm1',
  'pm2',
  'serviceLineRef',
  'tenantId',
  'ruolo',
  'assegnazionePerenne',
  'directory',
  'pim',
  'perimetri',
  'tecnici',
  'note',
  'contrattoNumero',
  'contrattoTipo',
  'contrattoInizio',
  'contrattoFine',
  'contrattoOre',
  'contrattoImporto',
  'contrattoNote'
];

const CLIENTI_TEMPLATE_EXAMPLE = [
  'NuovoClienteSrl',
  'Mario Rossi',
  'Lucia Bianchi',
  '',
  'Service Line Cloud',
  'tenant.onmicrosoft.com',
  'Contributor',
  'si',
  'membro',
  'no',
  'Azure|M365',
  'Massimiliano Barillari|Carlotta Murri',
  'Note libere',
  'C-2026-001',
  'Canone',
  '2026-01-01',
  '2026-12-31',
  '120',
  '12.000 €',
  'Rinnovabile 1 anno'
];

function downloadCsv(filename, rows) {
  // rows = array di array
  const csv = rows
    .map((r) =>
      r
        .map((cell) => {
          const s = String(cell == null ? '' : cell);
          return /[";,\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
        })
        .join(';')
    )
    .join('\n');
  downloadFile(filename, '﻿' + csv, 'text/csv');
}

function downloadTemplateClienti() {
  downloadCsv('template-import-clienti.csv', [CLIENTI_TEMPLATE_HEADER, CLIENTI_TEMPLATE_EXAMPLE]);
  toast('Template scaricato. Compila e re-importa.');
}

function downloadTemplateUtenti() {
  // duplicato del template gia presente in sicurezza ma con header esteso
  downloadCsv('template-import-utenti.csv', [
    ['email', 'name', 'role', 'resourceName', 'active'],
    ['mario.rossi@agic.it', 'Mario Rossi', 'utente', 'Mario Rossi', 'true'],
    ['admin2@agic.it', 'Admin Secondario', 'admin', '', 'true']
  ]);
  toast('Template utenti scaricato');
}

function downloadTemplateRisorse() {
  downloadCsv('template-import-risorse.csv', [['nome'], ['Mario Rossi'], ['Lucia Bianchi']]);
  toast('Template risorse scaricato');
}

function downloadTemplateScadenze() {
  downloadCsv('template-import-scadenze.csv', [
    ['cliente', 'titolo', 'tipo', 'data', 'completata', 'note'],
    [
      'ACQUALATINA',
      'Rinnovo certificato',
      'Certificato',
      '2026-09-30',
      'false',
      'Da rinnovare via PEC'
    ]
  ]);
  toast('Template scadenze scaricato');
}

async function importClientiFromCsv(file) {
  if (!isAdmin()) return;
  const text = await file.text();
  const rows = parseCSV(text);
  if (!rows.length) {
    toast('File vuoto');
    return;
  }
  const header = rows[0].map((h) => h.trim());
  const idx = {};
  CLIENTI_TEMPLATE_HEADER.forEach((k) => {
    idx[k] = header.indexOf(k);
  });
  if (idx.nome < 0) {
    toast('Colonna "nome" mancante nel CSV');
    return;
  }

  const ok = await confirmAction({
    level: 'warning',
    title: 'Importazione clienti',
    message: `Stai per importare ${rows.length - 1} clienti dal CSV.`,
    details: [
      'I clienti con lo stesso nome verranno aggiornati',
      'Le righe con nome vuoto verranno ignorate',
      'Le colonne "perimetri" e "tecnici" devono essere separate da "|"'
    ],
    warning: 'Operazione potenzialmente massiva. Crea un backup prima di proseguire.',
    confirmText: 'Importa'
  });
  if (!ok) return;

  let created = 0,
    updated = 0,
    skipped = 0;
  for (let i = 1; i < rows.length; i++) {
    const r = rows[i];
    const nome = (r[idx.nome] || '').trim();
    if (!nome) {
      skipped++;
      continue;
    }
    const get = (k) => (idx[k] >= 0 ? (r[idx[k]] || '').trim() : '');
    const arr = (k) =>
      get(k)
        .split('|')
        .map((s) => s.trim())
        .filter(Boolean);

    const client = {
      nome,
      cpl: get('cpl'),
      pm1: get('pm1'),
      pm2: get('pm2'),
      serviceLineRef: get('serviceLineRef'),
      tenantId: get('tenantId'),
      ruolo: get('ruolo'),
      assegnazionePerenne: get('assegnazionePerenne').toLowerCase(),
      directory: get('directory').toLowerCase(),
      pim: get('pim').toLowerCase(),
      perimetri: arr('perimetri'),
      tecnici: arr('tecnici'),
      note: get('note'),
      accessi: {},
      contratto: {
        numero: get('contrattoNumero'),
        tipo: get('contrattoTipo'),
        inizio: get('contrattoInizio'),
        fine: get('contrattoFine'),
        ore: get('contrattoOre'),
        importo: get('contrattoImporto'),
        note: get('contrattoNote')
      },
      referenti: [],
      documenti: [],
      scadenze: []
    };
    const existing = state.clients.find((c) => c.nome.toLowerCase() === nome.toLowerCase());
    try {
      // Preserva accessi/referenti/documenti/scadenze esistenti se update
      if (existing) {
        client.accessi = existing.accessi || {};
        client.referenti = existing.referenti || [];
        client.documenti = existing.documenti || [];
        client.scadenze = existing.scadenze || [];
      }
      await api.saveClient(client, existing?.nome || null);
      if (existing) updated++;
      else created++;
    } catch (e) {
      console.error('Riga ignorata', r, e);
      skipped++;
    }
  }
  await loadStateFromSupabase();
  logAudit({
    action: 'create',
    entity: 'Cliente',
    target: 'Import CSV',
    details: `Importati: ${created} creati, ${updated} aggiornati, ${skipped} ignorati`
  });
  renderAll();
  toast(`Import: ${created} creati · ${updated} aggiornati · ${skipped} ignorati`);
}

// I bottoni template/import vivono in viste lazy (clienti, scadenze, …):
// wiring idempotente (bindOnce), rieseguito a ogni iniezione di vista.
function wireImportClienti() {
  bindOnce(document.getElementById('btnTemplateClienti'), 'click', downloadTemplateClienti);
  bindOnce(document.getElementById('btnTemplateUtenti'), 'click', downloadTemplateUtenti);
  bindOnce(document.getElementById('btnTemplateRisorse'), 'click', downloadTemplateRisorse);
  bindOnce(document.getElementById('btnTemplateScadenze'), 'click', downloadTemplateScadenze);
  bindOnce(document.getElementById('fileImportClienti'), 'change', async (e) => {
    const f = e.target.files[0];
    e.target.value = '';
    if (f) await importClientiFromCsv(f);
  });
}
document.addEventListener('DOMContentLoaded', wireImportClienti);
globalThis.bus?.on?.('view:lazy-loaded', wireImportClienti);

Object.assign(globalThis, {
  downloadTemplateClienti,
  downloadTemplateUtenti,
  downloadTemplateRisorse,
  downloadTemplateScadenze,
  importClientiFromCsv
});
export {};
